export default __webpack_public_path__ + "static/media/scene-processed.f582ae83.glb";